<template>
  <div :class="`m-portal m-portal-${routeType}-page`">
    <portal-nav-top></portal-nav-top>
    <div id="ljh-travel">
      <div class="container-fluid" style="width:1100px;">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-dest-nav></portal-dest-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation">
                <span>首页</span>
                <span>&nbsp;>&nbsp;</span>
                <span>文化旅游</span>
                <span>&nbsp;>&nbsp;</span>
                <span
                  style="font-weight:bold;cursor: pointer;"
                  @click="travel('destinations','spot')"
                >景区景点</span>
              </div>
              <div class="container">
                <bs-detail :filter="filter" @on-data-after="handleTitle" :meta="meta" ref="refId">
                  <template slot="data" slot-scope="slot">
                    <portal-dest-detail-spot :result="slot"></portal-dest-detail-spot>
                  </template>
                  <template slot="empty">
                    <div class="list-none">
                      <ul></ul>
                    </div>
                  </template>
                </bs-detail>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <portal-footer></portal-footer>
  </div>
</template>
<script>
require("../../styles/portal/travel.scss");
import Vue from "vue";
import BaiduMap from "vue-baidu-map";
import vueSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(vueSwiper);

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "9862E14DE5d6373de36cd8e91503044b"
});
export default {
  data() {
    return {
      title: "",
      spot: true,
      hotel: false,
      ticket: false,
      food: false,
      routeType: "dest",
      activeIndex: "6",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        destId: this.$route.params._destId,
        root: true
      },
      api: null,
      swiperOption: {
        spaceBetween: 20,
        slidesPerView: 4,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  mounted() {},
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsDetail: () => import("../../components/bs-detail"),
    PortalDestDetailSpot: () => import("./portal-dest-detail-spot"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalNavLeft: () => import("./portal-nav-left"),
    PortalDestNav: () => import("./portal-dest-nav"),
    PortalFooter: () => import("./portal-footer")
  },
  methods: {
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/arti/detail/${_module}/${_field}_detail/${item.artiId}`
      });
    },
    travel(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/dest/page/${moudle}/${field}`
      });
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    },
    handleTitle(res) {
      this.$menuFn.setTitle(
        res.data.destName + "-景区景点-朱子文化·综合信息服务平台"
      );
    }
  },
  created() {},
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-dest-detail") {
        // this.$menuFn.setTitle("景区景点");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "detail",
        "portal",
        true
      );
      if (
        this.routeWatch &&
        contains &&
        this.$route.params._destId &&
        !to.hash
      ) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.filter.destId = this.$route.params._destId;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style type="text/scss" lang="scss" >
@import "../../styles/portal/culture-travel.scss";

.key {
  background: #e8d9bc;
  color: #520000;
  font-weight: bold;
}
.el-button--info.is-plain:hover,
.el-button--info.is-plain:focus {
  background: #520000;
  border-color: #909399;
  color: #e8d9bc;
}
</style>